(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-ring-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rr-ring-details')) {
    customElements.define('rr-ring-details', class extends HTMLElement {
      static selections = new Map();
      connectedCallback() {
        this.key = `${this.dataset.productId}:${this.dataset.formId}`;
        this.fields = Array.from(this.querySelectorAll('[name^="properties["]'));
        const saved = this.constructor.selections.get(this.key);
        if (saved) {
          this.fields.forEach((field) => {
            if (!Object.hasOwn(saved, field.name)) return;
            if (field.type === 'checkbox') field.checked = saved[field.name];
            else field.value = saved[field.name];
          });
          if (saved.engravingOpen) this.querySelector('details').open = true;
        }
        this.saveSelection = () => {
          const values = Object.fromEntries(this.fields.map((field) => [field.name, field.type === 'checkbox' ? field.checked : field.value]));
          values.engravingOpen = this.querySelector('details').open;
          this.constructor.selections.set(this.key, values);
        };
        this.addEventListener('input', this.saveSelection);
        this.addEventListener('change', this.saveSelection);
        this.querySelector('details').addEventListener('toggle', this.saveSelection);
      }
      disconnectedCallback() {
        this.removeEventListener('input', this.saveSelection);
        this.removeEventListener('change', this.saveSelection);
        this.querySelector('details')?.removeEventListener('toggle', this.saveSelection);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
